// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3SO7z","rootSmall":"AddTileButton_rootSmall__1xw0U"};